// @ts-ignore
import type * as RCL from 'rclnodejs';

import type { ForwardKinematicsRequest } from '@sb/motion-planning';
import { getRCL } from '@sb/ros/getRCL';

import { BaseService } from './BaseService';

type ForwardKinematicsBounds = Partial<
  Pick<
    ForwardKinematicsRequest,
    | 'checkEeBounds'
    | 'checkBodyBounds'
    | 'eePositionMin'
    | 'eePositionMax'
    | 'bodyPositionMin'
    | 'bodyPositionMax'
  >
>;

export class FKCheckService extends BaseService<
  'standard_bots_msgs/srv/FKCheck',
  RCL.standard_bots_msgs.srv.FKCheck_Request,
  RCL.standard_bots_msgs.srv.FKCheck_Response
> {
  private joint_state: RCL.sensor_msgs.msg.JointState;

  private check_collision: boolean;

  private bounds: ForwardKinematicsBounds;

  public constructor(
    joint_state: RCL.sensor_msgs.msg.JointState,
    check_collision: boolean,
    bounds: ForwardKinematicsBounds = {},
  ) {
    super();
    this.joint_state = joint_state;
    this.check_collision = check_collision;
    this.bounds = bounds;
  }

  protected override getType(): RCL.TypeClass<keyof RCL.ServicesMap> {
    return 'standard_bots_msgs/srv/FKCheck';
  }

  protected override getServiceName() {
    return 'solve_fk';
  }

  protected override async createRequest() {
    const rcl = await getRCL();

    const FKCheck = rcl.require('standard_bots_msgs/srv/FKCheck');

    const request = new FKCheck.Request();

    request.joint_state = this.joint_state;
    request.check_collision = this.check_collision;
    request.check_ee_bounds = this.bounds.checkEeBounds ?? false;
    request.check_body_bounds = this.bounds.checkBodyBounds ?? false;

    const toVector3 = (position?: { x: number; y: number; z: number }) => ({
      x: position?.x ?? 0,
      y: position?.y ?? 0,
      z: position?.z ?? 0,
    });

    request.ee_pos_min = toVector3(this.bounds.eePositionMin);
    request.ee_pos_max = toVector3(this.bounds.eePositionMax);
    request.body_pos_min = toVector3(this.bounds.bodyPositionMin);
    request.body_pos_max = toVector3(this.bounds.bodyPositionMax);

    return request;
  }

  protected override getTimeout(): number {
    return 1000;
  }
}
